import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import api from "./api";
import { PermsContext, DEFAULT_PERMS } from "./perms";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import ModulePage from "./pages/ModulePage";
import PIA from "./pages/PIA";
import Discovery from "./pages/Discovery";
import Reports from "./pages/Reports";
import Compliance from "./pages/Compliance";
import Calendar from "./pages/Calendar";
import Policies from "./pages/Policies";
import BulkConsent from "./pages/BulkConsent";
import Workflow from "./pages/Workflow";
import { EstateOverview, Machines, MachineDetail, EstateScans, Findings, Unencrypted } from "./pages/Estate";
import AgentServers from "./pages/AgentServers";
import SupportAccessTenant from "./pages/SupportAccessTenant";
import Login from "./pages/Login";
import { captureSsoToken, tenantTokenOk } from "./auth";

captureSsoToken(); // pick up ?token=... deep-links from the main portal

function Protected({ children }) {
  const loc = useLocation();
  if (!tenantTokenOk()) return <Navigate to="/login" replace state={{ from: loc }} />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  const [perms, setPerms] = useState(null);
  useEffect(() => {
    if (tenantTokenOk()) api.get("/me").then((r) => setPerms(r.data?.data)).catch(() => setPerms(null));
  }, []);
  return (
    <PermsContext.Provider value={perms || DEFAULT_PERMS}>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/m/:key" element={<Protected><ModulePage /></Protected>} />
      <Route path="/pia" element={<Protected><PIA /></Protected>} />
      <Route path="/discovery" element={<Protected><Discovery /></Protected>} />
      <Route path="/compliance" element={<Protected><Compliance /></Protected>} />
      <Route path="/calendar" element={<Protected><Calendar /></Protected>} />
      <Route path="/policies" element={<Protected><Policies /></Protected>} />
      <Route path="/consent-bulk" element={<Protected><BulkConsent /></Protected>} />
      <Route path="/workflow" element={<Protected><Workflow /></Protected>} />
      <Route path="/estate" element={<Protected><EstateOverview /></Protected>} />
      <Route path="/machines" element={<Protected><Machines /></Protected>} />
      <Route path="/machines/:id" element={<Protected><MachineDetail /></Protected>} />
      <Route path="/estate-scans" element={<Protected><EstateScans /></Protected>} />
      <Route path="/findings" element={<Protected><Findings /></Protected>} />
      <Route path="/unencrypted" element={<Protected><Unencrypted /></Protected>} />
      <Route path="/agent-servers" element={<Protected><AgentServers /></Protected>} />
      <Route path="/support-access" element={<Protected><SupportAccessTenant /></Protected>} />
      <Route path="/reports" element={<Protected><Reports /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </PermsContext.Provider>
  );
}
